import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type ActiveSeasonsInput,
  activeSeasonsInputSchema,
} from "./shared/activeSeasons.input";
import {
  type ActiveSeason,
  scheduleBaseSchema,
} from "./shared/activeSeasons.output";

/**
 * Metadata for the fetchActiveSeasons endpoint
 */
export const activeSeasonsMeta = {
  functionName: "fetchActiveSeasons",
  endpoint: "/activeseasons",
  inputSchema: activeSeasonsInputSchema,
  outputSchema: scheduleBaseSchema.array(),
  sampleParams: {},
  endpointDescription:
    "List all active schedule seasons with dates and PDF URLs.",
} satisfies EndpointMeta<ActiveSeasonsInput, ActiveSeason[]>;

/**
 * Fetch function for retrieving all active schedule seasons with dates and PDF URLs
 */
const { fetch, useHook } = createFetchAndHook<
  ActiveSeasonsInput,
  ActiveSeason[]
>({
  api: wsfScheduleApiMeta,
  endpoint: activeSeasonsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/activeSeasons.endpoints").activeSeasonsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all active schedule seasons with dates and PDF URLs
 */
export const fetchActiveSeasons: FetchFactory<
  ActiveSeasonsInput,
  ActiveSeason[]
> = fetch;

/**
 * React Query hook for retrieving all active schedule seasons with dates and PDF URLs
 */
export const useActiveSeasons: HookFactory<ActiveSeasonsInput, ActiveSeason[]> =
  useHook;
